import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DesyAngularModule } from 'desy-angular';
import { Rpt } from '@/app/interfaces/accession';
import { ApprovedActions } from '@/app/interfaces/accessionsList';
import { SpanishDatePipe } from '../../../pipe/date.pipe';
import { getCommonCardStateColor } from '../../../utils/card-state-color.utils';

@Component({
  selector: 'app-accession-card',
  standalone: true,
  imports: [DesyAngularModule, RouterModule, CommonModule, SpanishDatePipe],
  templateUrl: './accession-card.component.html',
  styleUrls: ['./accession-card.component.scss'],
})
export class AccessionCardComponent {
  @Input() approvedActions: ApprovedActions;
  @Input() title = '';
  @Input() id = '';
  @Input() creationDate: Date = new Date();
  @Input() buttonText?: string;
  @Input() buttonAction?: () => void;
  @Input() detailUrl = '';
  @Input() query?: unknown;
  @Input() service = '';
  @Input() rpts: Rpt[] = [];
  @Input() validatedTime: Date = new Date();

  private _state = '';
  @Input() set state(value: string) {
    this._state = value;
    this.color = getCommonCardStateColor(value);
  }
  get state(): string {
    return this._state;
  }

  color = '';

  get stateText(): string {
    switch (this.state?.toLowerCase()) {
      case 'rejected':
        return 'RECHAZADA';
      case 'pending':
        return 'PENDIENTE';
      case 'approved':
        return 'APROBADA';
      case 'disabled':
        return 'BLOQUEADA';
      case 'blocked':
        return 'BLOQUEADA';
      case 'finished':
        return 'FINALIZADA';
      default:
        return 'DESCONOCIDA';
    }
  }

  isOlderThan50Years(date: Date | string): boolean {
    const givenDate = new Date(date);
    const today = new Date();
    const fiftyYears = new Date(today.getFullYear() + 50, today.getMonth(), today.getDate());
    return fiftyYears > givenDate;
  }
}
